import { render, staticRenderFns } from "./VxSelect.vue?vue&type=template&id=98587042&lang=html&"
import script from "./VxSelect.vue?vue&type=script&lang=js&"
export * from "./VxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports